module.exports = __webpack_public_path__ + "assets/img/13722b13ff582d51a1570727bf3c67ad.svg";